import { render, staticRenderFns } from "./ManageQuestions.vue?vue&type=template&id=31fd7088&scoped=true&"
import script from "./ManageQuestions.vue?vue&type=script&lang=js&"
export * from "./ManageQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fd7088",
  null
  
)

export default component.exports